import { create } from "zustand";
import { ActionsKey } from "../../../../common/models/Actions";
import {
  initialGateInPageState,
  GateInItemData,
} from "../core/_model.gateIn";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../../common/models/StoreDefaultModel";

export type ActionedGateIn = {
  data: GateInItemData | null;
  action: ActionsKey;
};

type GateInDataType = {
  gateInList: any;
  detail: GateInItemData | null;
  actioned: ActionedGateIn | null;
  totalItems?: number;
  setDetail: (detail: GateInItemData | null) => void;
  setGateInList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedGateIn | null) => void;
};

export const useGateInStore = create<GateInDataType>(
  (set) => ({
    gateInList: [],
    detail: null,
    actioned: null,

    setDetail: (detail) => set((state) => ({ detail })),
    setGateInList: (saleData) =>
      set((state) => ({
        gateInList: saleData?.member,
        totalItems: saleData?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
  })
);

export const useGateInListState = create<DefaultListStateType>(
  (set) => ({
    pageState: initialGateInPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);
